exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".selectPaymentMethod.warningWrapper{padding-left:8px;padding-top:8px}.selectPaymentMethod.warningWrapper>*{vertical-align:middle}.selectPaymentMethod.addBankAccountBox{border:1px dashed #b3b3b3;padding:8px 10px;background-color:#fff}.vp-error .selectPaymentMethod.addBankAccountBox{border-color:#ff553d}", ""]);

// exports
